// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"038c9d24","242":"23fa1e42","751":"7cff3aa2"}[chunkId] + ".chunk.css";
};